// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'collab.my',
    path: 'project/:id/backer',
    name: 'ProjectBackerList',
    component: () => import('./PgProjectBackerList'),
    meta: {
      title: '資助者列表'
    }
  }
]
